import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ColorLabel } from '../../queries/usePaginateColorLabels'
import { api } from '@api'
import { showSuccessToast } from '@utils'
import { useLanguage } from '@context'
import { useApiErrorHandler } from '../../../useApiErrorHandler'

interface UpdateColorLabelData {
  id: string
  name?: string
  color?: string
  contactAccountIds?: string[]
}

interface ColorLabelResponse {
  colorLabel: ColorLabel
}

const updateColorLabel = async (data: UpdateColorLabelData): Promise<ColorLabelResponse> => {
  const { id, ...updateData } = data
  const { data: responseData } = await api.put<ColorLabelResponse>(`/color-label/${id}`, updateData)
  return responseData
}

export const useUpdateColorLabel = () => {
  const queryClient = useQueryClient()
  const { t } = useLanguage()
  const handleApiError = useApiErrorHandler()

  return useMutation<ColorLabelResponse, Error, UpdateColorLabelData>({
    mutationFn: updateColorLabel,
    onSuccess: async (_, variables) => {
      showSuccessToast(t('toast.success'), t('toast.colorUpdated'))
      await queryClient.invalidateQueries({ queryKey: ['color-labels'] })
      await queryClient.invalidateQueries({ queryKey: ['color-label', variables.id] })
      await queryClient.invalidateQueries({ queryKey: ['color-label-contacts', { id: variables.id }] })
    },
    // A refused save says so instead of failing in silence.
    onError: handleApiError,
  })
}

